<template>
    <router-view/>
  </template>
  <script>

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada. 
*/
  export default {
      beforeRouteUpdate(to, from, next) {
          if(to.name == 'formulario-consulta') {
              next({ name: 'formulario-consulta-list' })
          } else if(to.name == `${to.meta.abrev}-formulario-consulta`) {
            next({ name: `${to.meta.abrev}-formulario-consulta-list` })
          } else {
              next()
          }
      },
      created() {
          if(this.$route.name == 'formulario-consulta') {
              this.$router.push({ name: 'formulario-consulta-list' })
          } else if(this.$route.name == `${this.$route.meta.abrev}-formulario-consulta`) {
              this.$router.push({ name: `${this.$route.meta.abrev}-formulario-consulta-list` })
          } 
      }
  }
  </script>